const $body = document.body;
const $parent = document.createElement('div');
const $child = document.createElement('div');
$parent.style.overflow = 'scroll';
$parent.appendChild($child);
$body.appendChild($parent);
export default $parent.offsetWidth - $child.offsetWidth;
$body.removeChild($parent);

